import dayjs from 'dayjs';

const dateSplitterRe = /[:.\/-]/gm;

export const formatDate = (dt?: Date) => (dt ? dayjs(dt).utc(true).format('DD.MM.YYYY') : '');
export const formatDateTime = (dt: Date | string) => {
  const onlyDate = typeof dt == 'string' && dt.length <= 10;
  const format = onlyDate ? 'DD.MM.YYYY' : 'DD.MM.YYYY HH:mm:ss';
  const date = dayjs(dt).format(format);

  if (date === 'Invalid Date') return dt;

  return date;
};
export const formatRandomDateTime = (inputDate: string) => {
  let result = '';

  let date: Date | string = new Date(inputDate);
  if (date.toString() === 'Invalid Date') return inputDate;

  if (inputDate?.length <= 10) {
    const [ currentDate, month, year ] = inputDate.split(dateSplitterRe);
    date = new Date(+year, +month - 1, +currentDate);
  }

  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear().toString();
  result = `${day}.${month}.${year}`;

  if (inputDate?.length > 10) {
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');

    result = result + ` ${hours}:${minutes}:${seconds}`;
  }

  return result;
};
export const dateFormatOptions: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
};

export const toISODate = (date: any) => dayjs(dayjs(date).format('YYYY-MM-DD')).format('YYYY-MM-DDTHH:mm:ss');

export const formatRange = (start: Date, end: Date) => {
  let startText = dayjs(start).format('DD');

  if (start.getTime() === end.getTime()) {
    return dayjs(end).format('DD MMM');
  }

  if (start.getMonth() != end.getMonth()) {
    startText += dayjs(start).format(' MMM');
  }

  const endText = dayjs(end).format('DD MMM');
  return `${startText} - ${endText}`;
};

export const formatRangeDates = (start: Date, end: Date) => {
  if (start.getTime() === end.getTime()) {
    return formatDate(start);
  }

  return `${formatDate(start)} - ${formatDate(end)}`;
};
